<template>
  <Block title="互动答题" class="iv-m-t-24 iv-p-b-16" style="width: 384px;" @on-more="toMorePage">
    <ul class="iv-institutional-index iv-p-t-8" v-if="list.length > 0">
      <li
        class="iv-institutional-index-li iv-pull-left iv-m-t-16 iv-fc-65"
        v-for="item in list"
        :key="item.categoryId"
        @click="todetail(item)">
        <div class="prefix"></div>
        <p :title="item.examName">{{item.examName}}</p>
      </li>
    </ul>
    <NoData v-if="list.length <= 0"></NoData>
  </Block>
</template>

<script>
import Block from '@/components/block'
import NoData from '@/components/no-data'
import IconFont from '@/components/iconfont'
import { jumpElearningPage } from '@/utils'
// import {titleConfig} from './index-config.js'

export default {
  name: 'institutionalIndex',
  data () {
    return {
      list: []
    }
  },
  created () {
    this.$ajax({
      url: 'api-exam/portal/open/exam/examList',
      method: 'get',
      data: {
        currentPage: 1,
        pageSize: 4,
        token: sessionStorage.getItem('token')
      }
    }).then(({data}) => {
      this.list = data.data
    })
  },
  methods: {
    //点击更多
    toMorePage () {
      jumpElearningPage('/#/examlist')
    },
    todetail (item) {
      const { examineeState } = item
      if (examineeState === 1) {
        jumpElearningPage(`/#/paper?id=${item.examID}&paperID=${item.paperID}`)
      } else {
        jumpElearningPage('/#/examlist')
      }
      // if (examineeState === 0) {
      //   jumpElearningPage('/#/examlist')
      // } else {
      //   jumpElearningPage('/#/paper', { id: item.examID, paperID: item.paperID })
      // }
    }
  },
  components: {
    Block,
    NoData,
    IconFont
  }
}
</script>

<style lang="scss" scoped>
.iv-institutional-index {
  background: #fff;
  overflow: hidden;
  .iv-institutional-index-li {
    width: 100%;
    cursor: pointer;
    margin-right: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .prefix {
      width: 6px;
      height: 6px;
      background: #FFC757;
      border-radius: 50%;
    }
    p {
      margin: unset;
      margin-left: 8px;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.65);
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
